import React from "react";
import LBox, { LBoxProps } from "./LBox";
import LIcon, { IconName } from "./LIcon";
import LPressable from "./LPressable";
import LText from "./LText";

type LinkButtonProps = LBoxProps & {
  title: string;
  iconColor: string;
  iconName: Extract<IconName, "link">;
  iconSize?: number;
  onPress?: () => void;
  sentryEventName?: string;
};

const LinkButton = ({
  title,
  iconColor,
  iconName,
  onPress,
  iconSize,
  sentryEventName,
  ...rest
}: LinkButtonProps) => {
  return (
    <LPressable sentryEventName={sentryEventName || ""} onPress={onPress}>
      <LBox
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        height={44}
        borderRadius="s"
        padding="s2"
        backgroundColor="favouriteTileBg"
        {...rest}
      >
        <LText color="linkButtonText">{title}</LText>
        <LIcon colors={{ color: iconColor }} name={iconName} size={iconSize} />
      </LBox>
    </LPressable>
  );
};

export default LinkButton;
